module.exports = __webpack_public_path__ + "img/22.879d1e50.svg";